export default __webpack_public_path__ + "static/media/instagram-black.51e25620.svg";